import React from 'react';
import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import { useAppContext } from '@prisjakt/ui-app-context';

import { Row } from '@prisjakt/ui/list/variants';
import {
  TonalButton,
  ButtonSize,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import Clickable from '@prisjakt/ui-clickable';
import { Behavior } from '@prisjakt/ui/text';
import { IconMagnifier } from '@prisjakt/ui/icon';

import { addRecentSearch } from 'src/areas/search-suggestions/history-storage';
import { trackKeywordSuggestionClicked } from './tracking';

import { Keyword } from 'src/types';

type Props = {
  keywords: Keyword[];
  isMobile?: boolean;
};

export const KeywordSuggestions = (props: Props) => {
  const { keywords } = props;
  const { linkTo } = useAppContext();

  const handleClick = (query: string) => {
    trackKeywordSuggestionClicked(query);
    addRecentSearch(query);
  };

  return (
    <Keywords>
      <StyledRow gap={0.5} containerProps={{ 'data-test': 'KeywordQueries' }}>
        {keywords.slice(0, 4).map(
          keyword =>
            keyword?.query && (
              <Button
                key={keyword.query}
                size={ButtonSize.SMALL}
                onClick={() => handleClick(keyword.query)}
                container={Clickable as any}
                containerProps={{
                  to: linkTo('search', { query: keyword.query }),
                }}
              >
                <ButtonIcon>
                  <IconMagnifier />
                </ButtonIcon>
                <ButtonText behavior={Behavior.OnelineEllipsis}>
                  {keyword.query}
                </ButtonText>
              </Button>
            )
        )}
      </StyledRow>
    </Keywords>
  );
};

export const Keywords = styled.div`
  padding: 0 ${layout.measurements.spacing050} 0;
  margin-bottom: ${layout.measurements.spacing025};

  ${media.smallOnly`
    padding:0;
  `};
`;

const Button = styled(TonalButton)`
  overflow: hidden;

  ${media.smallOnly`
    overflow: visible;

    &:first-child {
      margin-left: ${layout.measurements.spacing050};
    }
    &:last-child {
      margin-right: ${layout.measurements.spacing050};
    }
    
  `};
`;

const StyledRow = styled(Row)`
  ${media.smallOnly`
    overflow: auto;
  `};
`;
